/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import 'react-native-reanimated';
import React from 'react';
import Text from '@components/common/Text';
import {
  WithSkiaWeb,
} from '@shopify/react-native-skia/lib/module/web';
import {
  version,
} from 'canvaskit-wasm/package.json';

const GraphWrapper = (props: PeanutsAndWrinklesGraphWrapperProps) => {
  return (
    <WithSkiaWeb
      opts={{locateFile: (file) => `https://cdn.jsdelivr.net/npm/canvaskit-wasm@${version}/bin/full/${file}`}}
      getComponent={() => import('./PeanutsAndWrinklesGraph')}
      fallback={<Text>Loading TODO...</Text>}// @TODO: loading indicator
      componentProps={{otherUser: props.otherUser}}
    />
  );
};

class PeanutsAndWrinklesGraphWrapperProps {
  otherUser: any;
};

export default GraphWrapper;
